<template>
  <form>
    <div class="order-operation-notes-modal modal-card">
      <header class="modal-card-head">
        <p class="modal-card-title has-text-weight-bold">Create Comment</p>
      </header>
      <section class="modal-card-body">
        <base-select
          name="vetted-note"
          :service="vettedStatementService"
          fetch-func="all"
          :fetch-params="vettedNoteFetchParams"
          label="Vetted Note"
          value-key="id"
          label-key="longText"
          :disabled="form.description != ''"
          @input="(val) => onInput('vetted_order_activity_id', val)"
        ></base-select>
        <b-field label="Description">
          <b-input
            name="description"
            type="textarea"
            :disabled="form.vetted_order_activity_id != ''"
            @input="(val) => onInput('description', val)"
          ></b-input>
        </b-field>
        <b-checkbox v-model="form.confidential">Confidential</b-checkbox>
      </section>

      <footer class="modal-card-foot">

        <button class="button" type="button" @click="$parent.close()">Cancel</button>

        <b-button id="create_comment" type="is-info" :disabled="buttonStatus" :loading="loadingStatus" @click.prevent="prepareAction('save')">Create</b-button>

        <!-- <button id="create_comment" :class="`button is-info ${loading ? 'is-loading' : ''}`" @click.prevent="prepareAction('save', 'button', 'loading')" ref="button">Create</button> -->

      </footer>

    </div>
  </form>
</template>

<script>
import BaseSelect from "@/components/partials/BaseSelect";
import { JsonDenormalizer } from "@/helpers/JsonDenormalizer";
import { OrderOperationService } from "@/services/orderOperation.service";
import { VettedStatementService } from "@/services/vettedStatement.service";

export default {
  props: {
    saveCallback: {
      type: Function,
      required: true
    },
    vettedNoteFetchParams: {
      type: Object,
      default: () => {}
    }
  },
  components: {
    BaseSelect
  },
  data: () => ({
    orderOperationService: OrderOperationService,
    vettedStatementService: VettedStatementService,
    form: {
      vetted_order_activity_id: "",
      description: "",
      confidential: false
    },
    loading: false
  }),
  methods: {
    onInput(key, val) {
      this.form[key] = val;
    },
    async save() {

      try {
        await this.saveCallback({
          ...this.form
        });

        this.$buefy.toast.open({
          message: "Note has been created.",
          type: "is-info",
          position: "is-top-right"
        });

        this.$emit("create");
        this.$parent.close();
      } catch (err) {}

    }

  }


};
</script>

<style scoped>
.modal-card-foot {
  justify-content: flex-end;
}
</style>



// WEBPACK FOOTER //
// src/components/Comment/CommentModal.vue